
// frontend/src/components/TestSnackbar.js

import React from 'react';
import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';

function TestSnackbar() {
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = () => {
    enqueueSnackbar('Это тестовое уведомление!', { variant: 'info' });
  };

  return (
    <div>
      <Button variant="contained" color="secondary" onClick={handleClick}>
        Показать уведомление
      </Button>
    </div>
  );
}

export default TestSnackbar;
